import { render } from "./MerchantTgGroupMultiselect.vue?vue&type=template&id=d51fe93a&ts=true"
import script from "./MerchantTgGroupMultiselect.vue?vue&type=script&lang=ts"
export * from "./MerchantTgGroupMultiselect.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__